import NiceModal from '@ebay/nice-modal-react';
import OrderCreateModal from 'ui-component/modals/orders/OrderCreateModal';

NiceModal.register('order-create-modal', OrderCreateModal);
